export const BASE_URL = process.env.REACT_APP_API_DOMAIN;

export const LOCALIZATION_KEY = "LOCALE";

export const STRING = {
  server_error: "Internal server error. Please try again later.",
  something_went_wrong: "Something went wrong. Please try again later."
}

export const WEB_ROUTES = {
  ACCOUNT: "account",
  HOME: "",
  QUIZ: "quiz",
  QUIZ_GAME: "quiz-game",
  CREATE_QUIZ: "create-quiz",
  EDIT_QUIZ: (id = ':id') => "edit-quiz/" + id,
  UPDATE_QUIZ: "edit-quiz",
  GAME: "game",
  QUIZ_HISTORY: "organize-quiz",
  QUESTION_HISTORY: "quiz-history",
  ADD_QUESTION: "add-question",
  UPDATE_QUESTION: "edit-question",
  LEADER_BOARD: "leader-board",
  TUTORIAL_LOGIN: "tutorial-login",
}


export const ROLE_TYPE_ENUM = {
  CONTESTANT: 10,
  AUDIENCE: 20,
}


export const QUIZ_STATUS = {
  UPCOMING: 10,
  ONGOING: 20,
  COMPLETED: 30,
  NOT_STARTED: 40,
}
export const QUESTION_TYPES = {
  MCQ: 10,
  BLANK: 20
}

export const OPTIONS_TYPES = {
  TEXT: 10,
  IMAGE: 20
}


export const BUZZER_PRESS_TIMER = 60 // Timer to press buzzer
export const BUZZER_RELEASE_TIMER = 60 // Timer in which buzzer is released automatically